var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop } from "vue-property-decorator";
import ResponsiveImage from "../ResponsiveImage.vue";
import Carousel from 'bootstrap-vue/es/components/carousel/carousel';
import CarouselSlide from 'bootstrap-vue/es/components/carousel/carousel-slide';
var ImageContent = /** @class */ (function (_super) {
    __extends(ImageContent, _super);
    function ImageContent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(ImageContent.prototype, "imagesArray", {
        get: function () {
            if (!this.images)
                return [];
            if (this.images instanceof Array)
                return this.images.map(function (p) { return p.src; });
            return [this.images];
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        Prop({ type: [Array, String, Object], default: function () { return []; } })
    ], ImageContent.prototype, "images", void 0);
    ImageContent = __decorate([
        Component({
            name: "ImageContent",
            components: {
                ResponsiveImage: ResponsiveImage,
                "b-carousel": Carousel,
                "b-carousel-slide": CarouselSlide
            }
        })
    ], ImageContent);
    return ImageContent;
}(Vue));
export default ImageContent;
;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/Components/Content/Image.vue
// module id = 176
// module chunks = 7 8 9